import { render, staticRenderFns } from "./FollowUpImport.vue?vue&type=template&id=7da871a4&"
import script from "./FollowUpImport.vue?vue&type=script&lang=js&"
export * from "./FollowUpImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports